export default [
    {
        key: 'example_client_feature',
        title: 'Example feature',
        description: 'This is an example of how a feature flag should be created.',
        owner: "René d'Herblay",
        test_value: true,
        default_value: true
    },
    {
        key: 'sensor_placement_readings',
        title: 'Sensor Placement Readings in Form',
        description: 'Get sensor readings by placement in form when using the sensor_question field',
        owner: 'Francisco Tejon',
        test_value: true,
        default_value: true
    },
    {
        key: 'limit_brand_wide_submissions',
        title: 'Limit brand wide submissions view',
        description:
            'Actities now require `permit_brandwide_submission_access` set before they show submissions on the brand wide submission page',
        owner: 'Anže Pečar',
        test_value: true,
        default_value: false
    },
    {
        key: 'push_registration_refactor',
        title: 'Push Notification Registration Refactor',
        description: 'Refactor push notification registration process on mobile to be tested and easier to maintain',
        owner: 'David Watkins',
        test_value: true,
        client: true
    },
    {
        key: 'clientside_invite_flow',
        title: 'Client-Side Invite Flow',
        description: 'Refactor the invite flow to avoid django templating',
        owner: 'Tanweer Rajwani',
        default_value: true,
        test_value: true
    },
    {
        key: 'fix_form_draft_photo_deletion',
        title: 'Fix form draft photo deletion',
        description: 'Fixes the draft photo deletion bug on native',
        owner: 'Sanghyun Lee',
        client: true,
        test_value: true
    },
    {
        key: 'avoid_unauthenticated_requests',
        title: 'Avoid unauthenticated requests',
        description: 'Avoid unauthenticated requests in the mobile app login screen',
        owner: 'Paul Guerrero',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'fix_machineq_qr',
        title: 'Fix MachineQ QR',
        description: 'Handle DevEUI only QRs',
        owner: 'Team Meow',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'get_content_type_from_raw_file',
        title: 'Get content type from raw file on mobile web',
        owner: 'Alexandra Gamazina',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'detect_low_quality_photos',
        title: 'Detect low-quality photos',
        owner: 'Yurii & Tejón',
        client: true,
        test_value: true,
        default_value: true
    },
    {
        key: 'image_quality_feature_web_app',
        title: 'Image quality feature for web',
        owner: 'Yurii Parfinenko',
        client: true,
        test_value: true,
        default_value: true
    },
    {
        key: 'select_all_questions_in_reports',
        title: 'Select all questions in reports',
        owner: 'Diego Dominguez',
        client: true,
        test_value: true,
        default_value: true
    },
    {
        key: 'login_improvements',
        title: 'Improve login for submitters',
        owner: 'Francisco Tejon',
        client: true,
        test_value: true,
        defailt_value: true
    },
    {
        key: 'prevent_showing_hidden_fields_on_form_prefill',
        title: 'Prevent showing hidden fields on form prefill',
        owner: 'Diego Dominguez',
        client: true,
        test_value: true,
        default_value: true
    },
    {
        key: 'new_submission_page',
        title: 'Rewrite submissions page in react',
        owner: 'Paul Guerrero',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'add_ai_actions',
        title: 'AI Actions on reports',
        owner: 'Yurii Parfinenko',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'add_ai_actions_submission',
        title: 'AI Actions on individual submission',
        owner: 'Yurii Parfinenko',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'photo_intelligence_feature_web_app',
        title: 'Photo intelligence features',
        owner: 'Team Meow',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'sensor_6m_history',
        title: 'Add 6m of sensor history',
        owner: 'Francisco Tejon',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'sensor_triggers_location_email',
        title: 'Add location email alert option to sensor trigger',
        owner: 'Francisco Tejon',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'add_forms_video_upload',
        title: 'Add video upload on forms media',
        owner: 'Sam Shorey',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'pendo_mobile_dashboard_tracking',
        title: 'Enable Pendo analytics for mobile dashboard',
        owner: 'Charlotte Resnick',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'pendo_mobile_screen_tracking',
        title: 'Enable Pendo per-screen entry analytics for the mobile app',
        owner: 'Charlotte Resnick',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'cosmetic_rebrand',
        title: 'Update branding from Zenput to Operations Execution',
        owner: 'Charlotte Resnick',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'follow_up_actions_form_reply',
        title: 'Follow up actions form reply',
        owner: 'Brian Adriance',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'rebrand_mobile_release',
        title: 'Rebranding that should only appear when the rebranded app is in the app stores',
        owner: 'Charlotte Resnick',
        client: true,
        test_value: true,
        default_value: false
    },
    {
        key: 'introduce_help_section',
        title: 'Introduce Help section',
        description: "Adds a 'Help' section with docs, chat and walkme buttons",
        owner: 'Yurii Parfinenko',
        client: true,
        test_value: true,
        default_value: false
    }
];
